import React from "react";

/**
 * Real recorded transport clip (bus + train routes on the map).
 * Falls back to the poster still if the GIF is missing.
 */
export default function HomeTransportStage() {
  return (
    <div className="ht-stage ht-stage--simple">
      <div className="ht-stage-visual">
        <img
          className="ht-stage-gif"
          src="/home-clips/transport-modes.gif?v=5"
          alt="Transit and car routes from Paddington to Tiffin Girls on the SchoolCatch map"
          loading="lazy"
          onError={(event) => {
            // Prefer the recorded still if GIF fails to load.
            event.currentTarget.onerror = null;
            event.currentTarget.src = "/home-clips/transport-modes.jpg?v=5";
          }}
        />
      </div>
      <div className="ht-stage-caption">
        <span className="ht-cap ht-cap--bus">Bus</span>
        <span className="ht-cap ht-cap--train">Train</span>
        <span className="ht-cap ht-cap--walk">Walk</span>
        <span className="ht-cap ht-cap--drive">Car</span>
        <p>Real routes from your pin — times for a Monday morning</p>
      </div>
    </div>
  );
}
